/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface QuoteManagerUpdateRequest
 */
export interface QuoteManagerUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof QuoteManagerUpdateRequest
     */
    newIdentityId?: string;
    /**
     * 
     * @type {string}
     * @memberof QuoteManagerUpdateRequest
     */
    invitationEmail?: string;
}

/**
 * Check if a given object implements the QuoteManagerUpdateRequest interface.
 */
export function instanceOfQuoteManagerUpdateRequest(value: object): value is QuoteManagerUpdateRequest {
    return true;
}

export function QuoteManagerUpdateRequestFromJSON(json: any): QuoteManagerUpdateRequest {
    return QuoteManagerUpdateRequestFromJSONTyped(json, false);
}

export function QuoteManagerUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuoteManagerUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'newIdentityId': json['newIdentityId'] == null ? undefined : json['newIdentityId'],
        'invitationEmail': json['invitationEmail'] == null ? undefined : json['invitationEmail'],
    };
}

export function QuoteManagerUpdateRequestToJSON(value?: QuoteManagerUpdateRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'newIdentityId': value['newIdentityId'],
        'invitationEmail': value['invitationEmail'],
    };
}

